import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, onPrepareAnonymousHeaders } from "@/redux/services/helpers";

export const loanApplicationService = createApi({
  reducerPath: "borrowerLoanOriginationService",
  tagTypes: ["BorrowerLoanOrigination"],
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: onPrepareAnonymousHeaders,
  }),
  endpoints: () => ({}),
});

